import React, { useContext, useEffect, useState } from "react";
import { Platform, Pressable, ScrollView, StyleSheet, View } from "react-native";
import { FindifyDataContext, FindifyDataContextType } from "@/contexts/FindifyDataContext";
import { PlaceColors } from "./helpers/PlaceColors";
import { PlaceText } from "./components/PlaceText";
import { DefaultShadow, IconShadow } from "./helpers/DefaultShadows";
import { BasePage } from "./helpers/BasePage";
import { FindifyTopBarOverlay } from "./components/FindifyTopBarOverlay";
import { BottomNavigationPadding, navigateToBottomBar } from "./components/FindifyNavigation";
import { useTranslation } from "react-i18next";
import { FindifySimpleHeader } from "./components/FindifySimpleHeader";
import { loadTicketCollection } from "./EventTicketCollectionZone";
import { FindifyInputBlockProps, FindifyInputRenderer, FindifyInputRendererProps, FindifyInputRendererType } from "./helpers/FindifyInputRender";
import { useForm } from "react-hook-form";
import { AddressTitle } from "@/base-values/BaseValues";
import Icon from "react-native-vector-icons/Ionicons";
import { getApiFromModule } from "./helpers/GetContentsByModule";
import { CountriesApi, PublicShopCartApi, PublicShopOrdersApi } from "@/findifyv2-api-ts";
import uuid from 'react-native-uuid';
import { FindifyToast } from "./components/FindifyToast";
import { Dropdown } from "react-native-element-dropdown";
import { FindifyBasicModal } from "./components/FindifyBasicModal";
import { useNavigation } from "@react-navigation/native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export const CheckoutPage = ({ navigation, ...props }: any) => {
    const findifyDataContext = useContext(FindifyDataContext);
    const { t } = useTranslation();
    const [cartLines, setCartLines] = useState<any[]>([]);
    const [addressModalOpen, setAddressModalOpen] = useState<boolean>(false);
    const [ticketLines, setTicketLines] = useState<any>({});
    const [ticketsToLoad, setTicketsToLoad] = useState<number[]>([]);
    const [ticketCollections, setTicketCollections] = useState<any[]>([]);
    const [processedTickets, setProcessedTickets] = useState<any[]>([]);
    const shopCartApi = getApiFromModule('shop_cart', findifyDataContext) as PublicShopCartApi;
    const shopOrderApi = getApiFromModule('shop_order', findifyDataContext) as PublicShopOrdersApi;
    const [userCart, setUserCart] = useState<any>({});
    const [customerBillingAddresses, setCustomerBillingAddresses] = useState<any[]>([]);
    const [countries, setCountries] = useState<any[]>([]);
    const [selectedCustomerBillingAddress, setSelectedCustomerBillingAddress] = useState<any>(null);
    const customerBillingAddressesApi = getApiFromModule('customer_billing_addresses', findifyDataContext) as PublicShopCartApi;
    const countriesApi = getApiFromModule('countries', findifyDataContext) as CountriesApi;


    // Update ticket list
    useEffect(() => {
        const newProcessedTickets: any = {};
        Object.keys(ticketCollections).length > 0 && Object.keys(ticketLines).length > 0 &&
            Object.keys(ticketLines)?.map((ticketCollectionId: any) => {
                const tickets = ticketLines[ticketCollectionId];
                const tc = ticketCollections[ticketCollectionId];
                newProcessedTickets[ticketCollectionId] = tickets.map((ticket: any) => {
                    const ticketData = tc.tickets.find((t: any) => t.shop_item_id === ticket.shop_item.shop_item_id);
                    const t = {
                        ...ticket,
                        'ticketData': ticketData,
                    }
                    return t;
                });
            });
        setProcessedTickets(newProcessedTickets);
    }, [ticketCollections, ticketLines])


    useEffect(() => {
        countriesApi.getList(0, 0, null, null, null).then((countries: any) => {
            setCountries(countries.results);
        });
        customerBillingAddressesApi.getList(0, 0, null, null, null).then((addresses: any) => {
            setCustomerBillingAddresses(addresses.results);
        });
        shopCartApi.getList(0, 0, null, null, { orderby: JSON.stringify({ shop_item_id: "ASC" }) }).then((cart: any) => {
            setUserCart(cart.results);
        });
    }, [])

    // Process tickets on cart update
    useEffect(() => {
        const cart = userCart
        let tLines: any = {};
        let cLines: any[] = [];
        let newTicketsToLoad: number[] = [];
        Object.keys(cart ?? {}).map((item_key: any) => {
            const item = cart[item_key];
            if (item?.shop_item?.ticket_collection_ticket) {
                // IS A TICKET
                const ticketCollectionId = item?.shop_item?.ticket_collection_ticket?.ticket_collection_id;
                if (!newTicketsToLoad.includes(ticketCollectionId)) {
                    newTicketsToLoad.push(ticketCollectionId);
                }
                if (tLines[ticketCollectionId]) {// Update 
                    tLines[ticketCollectionId].push(item);
                } else { // ADD
                    tLines[ticketCollectionId] = [item];
                }
            } else {
                // TODO : ITEMS
            }
        });
        setCartLines(cLines);
        setTicketLines(tLines);
        setTicketsToLoad(newTicketsToLoad);
    }, [userCart]);

    // ticektsToLoad that exist in cart(tickets to load should not change as checkout only allows to delete)
    useEffect(() => {
        let ticketCollectionsData: any = {};
        ticketsToLoad.map((ticketCollectionId: number) => {
            loadTicketCollection(findifyDataContext, ticketCollectionId).then((tc: any) => {
                ticketCollectionsData[ticketCollectionId] = tc;
                if (Object.keys(ticketCollectionsData).length === ticketsToLoad.length) {
                    setTicketCollections(ticketCollectionsData);
                }
            })
        })
    }, [ticketsToLoad])

    return <BasePage navigation={navigation}>
        <FindifyTopBarOverlay />
        <ScrollView
            bounces={false}
            showsHorizontalScrollIndicator={false}
            showsVerticalScrollIndicator={false}
            style={[styles.container, { backgroundColor: PlaceColors(findifyDataContext).background.get() }]}>
            <FindifySimpleHeader

                title={t('base.tickets.checkout')}
                navigation={navigation}
            />
            {/* // TODO SUPPORT ADDRESS */}
            <View
                style={{
                    padding: 10,
                    paddingBottom: 10 + BottomNavigationPadding,
                    backgroundColor: PlaceColors(findifyDataContext).alternateListBG.get(),
                    margin: 10,
                    borderRadius: 10,
                }}
            >
                {/* ADDRESS */}
                <Dropdown
                    style={[{
                        borderWidth: 1,
                        // padding: 5,
                        paddingHorizontal: 5,
                        borderRadius: 6,
                        borderColor: PlaceColors(findifyDataContext).text.get(),
                        color: PlaceColors(findifyDataContext).text.get(),
                        backgroundColor: PlaceColors(findifyDataContext).background.get()
                    }, DefaultShadow]}
                    data={customerBillingAddresses ?? []}
                    search={true}
                    maxHeight={300}
                    labelField="line1"
                    value={selectedCustomerBillingAddress}
                    valueField="customer_billing_address_id"
                    onChange={item => {
                        setSelectedCustomerBillingAddress(item)
                    }}
                />
                <Pressable
                    style={{
                        backgroundColor: PlaceColors(findifyDataContext).text.get(),
                        borderRadius: 10,
                        padding: 10,
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: 10,

                    }}
                    onPress={() => {
                        // OPEN MODAL
                        setAddressModalOpen(true);
                    }}
                >
                    <PlaceText style={{ color: PlaceColors(findifyDataContext).alternateListBG.get() }}>{t('base.tickets.add_address')}</PlaceText>
                </Pressable>
                {selectedCustomerBillingAddress &&
                    <View
                        style={{
                            // backgroundColor: 'blue',
                            borderBottomWidth: 1,
                            paddingBottom: 10,
                            marginBottom: 10,
                            borderBottomColor: PlaceColors(findifyDataContext).primary.get(),
                        }}
                    >
                        <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), fontWeight: 'bold' }}>{`${selectedCustomerBillingAddress?.title} ${selectedCustomerBillingAddress?.first_name} ${selectedCustomerBillingAddress?.last_name}`}</PlaceText>
                        {selectedCustomerBillingAddress.line1 && <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), }}>{`${countries.find((c) => c.country_id == selectedCustomerBillingAddress.country_id)?.name} ${selectedCustomerBillingAddress.city} ${selectedCustomerBillingAddress.county} `}</PlaceText>}
                        {selectedCustomerBillingAddress.line1 && <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), }}>{`${selectedCustomerBillingAddress.line1}`}</PlaceText>}
                        {selectedCustomerBillingAddress.line2 && <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), }}>{`${selectedCustomerBillingAddress.line2}`}</PlaceText>}
                        {selectedCustomerBillingAddress.postcode && <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), }}>{`${selectedCustomerBillingAddress.postcode}`}</PlaceText>}
                        {selectedCustomerBillingAddress.phone_number && <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), }}>{`${selectedCustomerBillingAddress.phone_number} | ${selectedCustomerBillingAddress.email}`}</PlaceText>}
                        {selectedCustomerBillingAddress.nif && <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), }}>{`${selectedCustomerBillingAddress.nif}`}</PlaceText>}
                    </View>
                }
                {/* Tickets */}
                {Object.keys(ticketCollections).length > 0
                    && Object.keys(ticketLines).length > 0 &&
                    Object.keys(ticketLines)?.map((ticketCollectionId: any) => {
                        const tc = ticketCollections[ticketCollectionId];
                        return <View>
                            <MakeEventSectionZone
                                shopCartApi={shopCartApi}
                                setUserCart={setUserCart}
                                shopOrderApi={shopOrderApi}
                                findifyDataContext={findifyDataContext}
                                processedTickets={processedTickets[ticketCollectionId]}
                                ticketCollection={tc} />
                        </View>
                    })}
                {/* Store */}
                <View
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        // alignItems: 'center',
                    }}
                >

                    <PlaceText>{t('base.tickets.total')}</PlaceText>
                    <PlaceText style={{ marginLeft: 'auto' }}>{printTicketPrice(makeTotalPrice(processedTickets))}</PlaceText>
                </View>
                <Pressable
                    style={{
                        borderWidth: 1,
                        backgroundColor: PlaceColors(findifyDataContext).alternateListBG.get(),
                        borderColor: PlaceColors(findifyDataContext).text.get(),
                        borderRadius: 10,
                        padding: 10,
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: 10,
                        marginBottom: 0
                    }}
                    onPress={() => {
                        // TODO RESET CART
                        shopCartApi.deleteBulk(null, null, null).then((res: any) => {
                            FindifyToast({
                                id: uuid.v4(),
                                visibilityTime: 1500,
                                type: 'success',
                                message: t('checkout.cart_updated_successfully'),
                            })
                            navigateToBottomBar({ navigation, path: 'Place' })
                        }).catch((err: any) => {
                            FindifyToast({
                                id: uuid.v4(),
                                visibilityTime: 1500,
                                type: 'error',
                                message: t('checkout.error_updating_cart'),
                            })
                        })
                    }}
                >
                    <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get() }}>{t('base.tickets.clear_checkout')}</PlaceText>
                </Pressable>
                {selectedCustomerBillingAddress &&
                    <Pressable
                        style={{
                            backgroundColor: PlaceColors(findifyDataContext).text.get(),
                            borderRadius: 10,
                            padding: 10,
                            justifyContent: 'center',
                            alignItems: 'center',
                            margin: 10,

                        }}
                        onPress={() => {
                            shopOrderApi.create(userCart[0].cart_id, {
                                "shop_order_billing_address_id": selectedCustomerBillingAddress?.customer_billing_address_id,
                            }, null, null)
                                .then((res) => {
                                    // Redirect to payment method
                                    // Paypal
                                    shopOrderApi.createOrder({
                                        "language": findifyDataContext.language,
                                        "order_id": res.shop_order_id,
                                    }, null, null)
                                        .then((resPP) => {
                                            // Open webview with paypal payment method
                                            const link = resPP.links.find((link: any) => link.rel === 'payer-action');
                                            if (link) {
                                                navigation.push('WebViewPage', {
                                                    url: link.href, title: t('checkout.payment'), hideMenu: true, hideGoBack: true, onNavigationStateChange: async (e: any, webviewNav: any) => {
                                                        if (e.url.startsWith('https://example.com/returnUrl')) {
                                                            // POST TO API
                                                            await navigateToBottomBar({ navigation, path: 'Place' });
                                                            shopOrderApi.aprove_order_payment(resPP.id, {}, null).then((res: any) => {
                                                                FindifyToast({
                                                                    id: uuid.v4(),
                                                                    visibilityTime: 3000,
                                                                    type: 'success',
                                                                    message: t('checkout.checkout_success'),
                                                                })
                                                            }).catch((err: any) => {
                                                                FindifyToast({
                                                                    id: uuid.v4(),
                                                                    visibilityTime: 3000,
                                                                    type: 'error',
                                                                    message: t('checkout.checkout_error'),
                                                                })
                                                            })
                                                        } else if (e.url.startsWith('https://example.com/cancelUrl')) {
                                                            // TOAST OF CANCEL
                                                            await navigation.goBack();
                                                            FindifyToast({
                                                                id: uuid.v4(),
                                                                visibilityTime: 3000,
                                                                type: 'error',
                                                                message: t('checkout.checkout_cancelled'),
                                                            })
                                                        }
                                                    }
                                                });
                                            } else {
                                                FindifyToast({
                                                    id: uuid.v4(),
                                                    visibilityTime: 3000,
                                                    type: 'error',
                                                    message: t('checkout.checkout_error'),
                                                })
                                            }
                                        });
                                })
                                .catch((err) => {
                                    // TOAST ERROR
                                    FindifyToast({
                                        id: uuid.v4(),
                                        visibilityTime: 3000,
                                        type: 'error',
                                        message: t('checkout.checkout_error'),
                                    })
                                });
                        }}
                    >
                        <PlaceText style={{ color: PlaceColors(findifyDataContext).alternateListBG.get() }}>{t('base.tickets.checkout')}</PlaceText>
                    </Pressable>
                }
            </View>
            <AddAddressModal
                countries={countries}
                findifyDataContext={findifyDataContext}
                t={t}
                setCustomerBillingAddresses={setCustomerBillingAddresses}
                customerBillingAddressesApi={customerBillingAddressesApi}
                customerBillingAddresses={customerBillingAddresses}
                addressModalOpen={addressModalOpen}
                setAddressModalOpen={setAddressModalOpen}
            />
        </ScrollView>
    </BasePage>;
}



const AddAddressModal = ({
    findifyDataContext,
    t,
    setCustomerBillingAddresses,
    customerBillingAddressesApi,
    customerBillingAddresses,
    addressModalOpen,
    setAddressModalOpen,
    countries,

}: any) => {
    const navigation = useNavigation();
    const insets = useSafeAreaInsets();
    const formFields: FindifyInputBlockProps[][] = [
        [

            {
                label: t('address.title'),
                fieldKey: 'title',
                type: FindifyInputRendererType.Dropdown,
                dropdownData: AddressTitle(t),
                required: true,
            },
        ],
        [
            {
                label: t('address.first_name'),
                fieldKey: 'first_name',
                type: FindifyInputRendererType.Text,
                required: true
            },
            {
                label: t('address.last_name'),
                fieldKey: 'last_name',
                type: FindifyInputRendererType.Text,
                required: true
            },
        ], [

            {
                label: t('address.line1'),
                fieldKey: 'line1',
                type: FindifyInputRendererType.Text,
                textContentType: "streetAddressLine1",
                required: true
            },
        ], [

            {
                label: t('address.line2'),
                fieldKey: 'line2',
                type: FindifyInputRendererType.Text,
                textContentType: "streetAddressLine1",
            },
        ],
        [{
            label: t('address.country'),
            fieldKey: 'country_id',
            type: FindifyInputRendererType.Dropdown,

            dropdownData: countries.map((c: any) => {
                return {
                    label: c.name,
                    value: c.country_id
                }
            }),
            required: true
        },
        {
            label: t('address.city'),
            fieldKey: 'city',
            type: FindifyInputRendererType.Text,
            required: true
        }],
        [{
            label: t('address.county'),
            fieldKey: 'county',
            type: FindifyInputRendererType.Text,
            required: true
        },
        {
            label: t('address.postcode'),
            fieldKey: 'postcode',
            type: FindifyInputRendererType.Text,
            textContentType: "postalCode",
            required: true
        }],
        [{
            label: t('address.email'),
            fieldKey: 'email',
            type: FindifyInputRendererType.Text,
            textContentType: "emailAddress",
            validate: {
                minLength: (v: string) => v?.length ?? 0 >= 3,
                maxLength: (v: string) => v?.length ?? 0 <= 250, //  "The email should have at most 50 characters",
                invalidEmail: (v: string) => /\S+@\S+\.\S+/.test(v ?? ''), //  "Email address must be a valid address",
            },
            required: true
        },
        {
            label: t('address.phone_number'),
            fieldKey: 'phone_number',
            type: FindifyInputRendererType.Text,
            required: true
        }],

        [{
            label: t('checkout.vat'),
            fieldKey: 'vat',
            type: FindifyInputRendererType.Text,
            // required: true
        }],
        // {
        //     label: t('checkout.terms_and_conditions'),
        //     fieldKey: 'terms_and_conditions',
        //     type: FindifyInputRendererType.CheckBox,
        //     required: true
        // },

    ];

    const form = useForm();

    return <FindifyBasicModal
        isOpen={addressModalOpen}
        closeModal={() => {
            setAddressModalOpen(false)
        }}
        style={{
            alignItems: 'center',
            justifyContent: 'center',
            maxWidth: '100%',
            minWidth: '100%',
            minHeight: '100%',
            maxHeight: '100%',
        }}
    >
        <ScrollView
            style={{
                paddingHorizontal: 10,
                paddingTop: insets.top,
                minWidth: '100%',
                backgroundColor: PlaceColors(findifyDataContext).alternateListBG.get(),
            }}
        >
            <View
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 6,
                    justifyContent: 'space-between',
                    alignItems: 'center',

                }}
            >
                <PlaceText style={
                    [
                        {
                            width: 'auto',
                            color: PlaceColors(findifyDataContext).primary.get(),
                            marginTop: Platform.OS === 'ios' ? 5 : 2,
                            fontSize: 24,
                            fontWeight: 'bold',
                            marginLeft: 0,
                            bottom: undefined,
                        },
                    ]
                }>{t('base.tickets.add_address')}</PlaceText>
                <Pressable
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 6,
                        marginLeft: "auto"
                    }}
                    onPress={() => setAddressModalOpen(false)}>
                    <Icon style={{ color: PlaceColors(findifyDataContext).sidebarTextColor.get() }} name={'chevron-back'} size={26} />
                </Pressable>
            </View>
            {formFields.map((line: any) => {
                return <View
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 10,
                        maxWidth: '100%',
                        // marginBottom: 10,

                    }}
                >
                    {line.map((field: any) => {
                        return <FindifyInputRenderer
                            style={{ flex: 1 }}
                            findifyDataContext={findifyDataContext}
                            form={form}
                            t={t}
                            fieldData={field}
                        />
                    })}
                </View>
            })}
            <Pressable
                style={{
                    backgroundColor: PlaceColors(findifyDataContext).text.get(),
                    borderRadius: 10,
                    padding: 10,
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: 10,
                    marginBottom: 40,
                }}
                onPress={() => {
                    form.handleSubmit(() => {
                        customerBillingAddressesApi.create(form.getValues(), null, null).then((address: any) => {
                            // TOAST SUCCESS
                            FindifyToast({
                                id: uuid.v4(),
                                visibilityTime: 1500,
                                type: 'success',
                                message: t('checkout.success_creating_address'),
                            })
                            setAddressModalOpen(false)
                            // Reload addresses
                            customerBillingAddressesApi.getList(0, 0, null, null, null).then((addresses: any) => {
                                setCustomerBillingAddresses(addresses.results);
                            })
                        }).catch((err: any) => {
                            FindifyToast({
                                id: uuid.v4(),
                                visibilityTime: 1500,
                                type: 'error',
                                message: t('checkout.error_creating_address'),
                            })
                        })
                    })()
                }}
            >
                <PlaceText style={{ color: PlaceColors(findifyDataContext).alternateListBG.get() }}>{t('base.tickets.add_address')}</PlaceText>
            </Pressable>
        </ScrollView>
    </FindifyBasicModal>

}


const MakeEventSectionZone = ({
    shopCartApi,
    setUserCart,
    shopOrderApi,
    processedTickets,
    ticketCollection,
    findifyDataContext,
}: {
    setUserCart: any,
    shopCartApi: PublicShopCartApi,
    shopOrderApi: PublicShopOrdersApi,
    processedTickets: any[],
    ticketCollection: any,
    findifyDataContext: FindifyDataContextType,
}) => {
    const { t } = useTranslation();
    return <View
        style={{
            // backgroundColor: 'blue',
            borderBottomWidth: 1,
            paddingBottom: 10,
            marginBottom: 10,
            borderBottomColor: PlaceColors(findifyDataContext).primary.get(),
        }}
    >
        <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), fontWeight: 'bold' }}>{ticketCollection?.name}</PlaceText>
        <PlaceText style={{ color: PlaceColors(findifyDataContext).text.get(), marginBottom: 20 }}>{ticketCollection?.description}</PlaceText>
        {processedTickets?.map((ticket: any) => {
            return <View
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginBottom: 10
                }}
            >
                <PlaceText>{ticket.quantity}x {ticket.ticketData?.ticket_type?.name} | {ticket.ticketData?.ticket_section?.section_name} {ticket.seated_row ? `| ${ticket.seated_row}` : ''} {ticket.seated_column ? `${ticket.seated_column}` : ''} - {printTicketPrice(ticket.ticketData?.price)}</PlaceText>
                <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 4 }}>
                    <PlaceText>{printTicketPrice(ticket.quantity * (ticket.shop_item?.ticket_collection_ticket?.price ?? 0))}</PlaceText>
                    <Icon
                        onPress={() => {
                            // DELETE FROM CART
                            shopCartApi.delete(ticket.cart_item_id, null, null).then((res: any) => {
                                FindifyToast({
                                    id: uuid.v4(),
                                    visibilityTime: 3000,
                                    type: 'success',
                                    message: t('checkout.sucess_removing_item'),
                                })
                                // UPDATE CART
                                shopCartApi.getList(0, 0, null, null, { orderby: JSON.stringify({ shop_item_id: "ASC" }) }).then((cart: any) => {
                                    setUserCart(cart.results);
                                })
                            }).catch((err: any) => {
                                console.log('err', err);
                                FindifyToast({
                                    id: uuid.v4(),
                                    visibilityTime: 3000,
                                    type: 'error',
                                    message: t('checkout.error_removing_item'),
                                })
                            });
                        }}
                        name="trash-outline" size={15} color={'red'} />
                </View>

            </View>
        })}

    </View >
}

const makeTotalPrice = (processedTickets: any) => {
    let total = 0;
    Object.keys(processedTickets)?.map((tcId: string) => {
        const tc = processedTickets[tcId];
        tc.forEach((ticket: any) => {
            total += ticket.quantity * (ticket.shop_item?.ticket_collection_ticket?.price ?? 0);
        })
    })
    return total;
}


const printTicketPrice = (value: any) => {
    const formattedValue = parseFloat(value).toFixed(2); // Fix the decimal places to 2
    return `${formattedValue} €`;
}
const styles = StyleSheet.create({
    text: {
        padding: 10,
        paddingBottom: 10 + BottomNavigationPadding,
    },
    container: {
        height: '100%',
        width: '100%',
    },

    headerIcon: {
        padding: 5,
        ...IconShadow,
    }
})
